import Link from "next/link";
import HeadingComponent from "../UserInterface/HeadingComponent";
import { BlockComponent } from "../UserInterface/BlockComponent";
import { DataAwards } from "../../data/DataAwards";

const AboutAchievement = () => {
  return (
    <div className="about-achievement-wrapper">
      <HeadingComponent headingText="Penghargaan Kami" margin="16px" />
      <div className="about-achievement-item-wrapper">
        {DataAwards.slice(0, 3).map((data, key) => {
          return (
            <div className="item" key={key}>
              <BlockComponent
                name={data.name}
                icon={data.image}
                items={data.items}
                minHeight="286px"
              />
            </div>
          );
        })}
      </div>
      <Link
        href="/tentang-perusahaan/penghargaan-kami"
        as="/tentang-perusahaan/penghargaan-kami"
      >
        <a className="about-achievement-more">
          <h3>Lihat Semua</h3>
        </a>
      </Link>
      <style jsx>
        {`
          .about-achievement-wrapper {
            max-width: 960px;
            width: 100%;
            padding: 16px 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            align-self: center;
          }
          .about-achievement-item-wrapper {
            display: flex;
            width: 100%;
            overflow: auto;
          }
          .item {
            min-width: 300px;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 0 8px;
          }
          .about-achievement-more {
            font-weight: bold;
            margin-bottom: 0;
            color: red;
            font-size: 15px;
            margin: 16px;
            align-self: flex-end;
          }

          @media only screen and (max-width: 1024) {
            .about-achievement-item-wrapper {
              width: 100vw;
              overflow: auto;
            }
            .about-achievement-more {
              margin: 16px;
            }

          @media only screen and (max-width: 768px) {
            .about-achievement-item-wrapper {
              width: 100vw;
              overflow: auto;
            }
            .about-achievement-more {
              margin: 16px;
            }

          @media only screen and (max-width: 600px) {
            .about-achievement-item-wrapper {
              width: 100vw;
              overflow: auto;
            }
            .item {
              width: 300px;
            }

            .about-achievement-more {
              font-size: 12px;
              margin: 16px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default AboutAchievement;
